import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HandelspartnerResource} from '@services/resource/handelspartner-resource';
import {ConfigService} from '@services/infra/config.service';

@Injectable({
  providedIn: 'root',
})
export class HandelspartnerService {
  constructor(
    private readonly conf: ConfigService,
    private readonly http: HttpClient,
  ) {}

  getHandelspartner(): Observable<HandelspartnerResource[]> {
    const url = `${this.conf.backendUrl}/v1/handelspartner`;
    return this.http.get<HandelspartnerResource[]>(url);
  }
}
